export const resizeIframe = function (e, zoomFactor = 1) {
  const extraPadding = 20;

  this.style.visibility = 'visible';
  this.style.height = (this.contentWindow.document.body.firstChild.clientHeight + extraPadding) / zoomFactor + 'px';
  this.style.width = (this.contentWindow.document.body.firstChild.clientWidth + extraPadding) / zoomFactor + 'px';
};
